import newRemarkModal from '@app/shared/vue/components/new-remark/new-remark-modal.vue'
import editRemarkModal from '@app/shared/vue/components/new-remark/edit-remark-modal.vue'
import autoReconcileModal from '@app/application/reconciliation/sections/auto-reconciliation/components/auto-reconcile-modal.vue'
import copyReconciliationDataModal from '@app/application/reconciliation/sections/copy-reconciliation-data/components/copy-reconciliation-data-modal.vue'
import insightsPeriodSelection from '@app/insights/components/period-selection.vue'
import restoreDefaultConfirmationModal from '@app/templates/components/restore-default-confirmation-modal.vue'
import accountSelectorModal from '@app/application/reconciliation/sections/account-selector/account-selector-modal.vue'
import accountEntriesModal from '@app/application/reconciliation/sections/account-entries-modal/account-entries-modal.vue'
import CompanyConsolidationSettingsModal from '@app/application/company_consolidations/components/company-consolidation-settings-modal.vue'
import exportSelectFromDocumentsModal from '@app/application/export/screens/select-from-documents-modal/components/index.vue'
import reportDisplayOptionsModal from '@app/application/report/sections/display-options-modal.vue'
import reportAnalyticalDimensionsModal from '@app/application/report/sections/analytical-dimensions-modal.vue'
import reportXlsxExportModal from '@app/application/report/sections/xlsx-export-modal.vue'
import moveDocumentModal from '@app/application/document/screens/move-modal/components/move-document-modal.vue'
import usersConfigureEmailNotificationsConfirmModal from '@app/users/components/configure/email-notifications-confirm-modal.vue'
import usersConfigureEnforceSsoAccessConfirmModal from '@app/users/components/configure/enforce-sso-access-confirm-modal.vue'
import UnlockAccountNumbersModal from '@app/application/accounts/unlock-account-numbers-modal.vue'
import CustomReportingModal from '@app/application/report/custom-reporting-modal.vue'
import ManagementAccountsModal from '@app/application/report/management-accounts-modal.vue'
import reportTemplateRemovalModal from '@app/application/report-template/report-template-removal-modal.vue'
import TemplateChildrenModal from '@app/shared/vue/components/template-children-modal.vue'
import OverlappingPackageDeactivationModal from '@app/application/marketplace/overlapping-package-deactivation-modal.vue'
import WistiaVideoModal from '@app/application/trial/wistia-video-modal.vue'
import ContactProductModal from '@app/application/trial/contact-product-modal.vue'
import ConfirmUnreviewTemplateModal from '@app/application/workflows/screens/workflow-review/components/confirm-unreview-template-modal.vue'
import ConfirmChangeAccountDetailTemplateModal from '@app/application/sf-assistant-checks/actions/confirm-change-account-detail-template-modal.vue'
import ConfirmAcceptReconciliationProposalModal from '@app/application/reconciliation/sections/proposals/confirm-accept.vue'
import ConfirmDeclineReconciliationProposalModal from '@app/application/reconciliation/sections/proposals/confirm-decline.vue'
import PinnedMessageRemovalModal from '@app/application/communication/sections/communication/components/pinned-message-removal-modal.vue'
import RecurringTodoRemovalModal from '@app/application/communication/sections/communication/components/recurring-todo-removal-modal.vue'
import PeriodScopeForUpdateModal from '@app/shared/vue/components/new-remark/period-scope-for-update-modal.vue'
import InvoiceContentLicenseDetailsModal from '@app/application/invoices/handlers/license-details-modal.vue'

export default {
  'new-remark': newRemarkModal,
  'edit-remark': editRemarkModal,
  'auto-reconcile': autoReconcileModal,
  'insights-period-selection': insightsPeriodSelection,
  'company-consolidation-settings-modal': CompanyConsolidationSettingsModal,
  'account-selector-modal': accountSelectorModal,
  'restore-default-confirmation-modal': restoreDefaultConfirmationModal,
  'account-entries-modal': accountEntriesModal,
  'export-select-from-documents-modal': exportSelectFromDocumentsModal,
  'report-display-options-modal': reportDisplayOptionsModal,
  'report-analytical-dimensions-modal': reportAnalyticalDimensionsModal,
  'report-xlsx-export-modal': reportXlsxExportModal,
  'report-template-removal-modal': reportTemplateRemovalModal,
  'overlapping-package-deactivation-modal': OverlappingPackageDeactivationModal,
  'move-document-modal': moveDocumentModal,
  'copy-reconciliation-data-modal': copyReconciliationDataModal,
  'users-configure-email-notifications-confirm-modal':
    usersConfigureEmailNotificationsConfirmModal,
  'users-enforce-sso-access-confirm-modal':
    usersConfigureEnforceSsoAccessConfirmModal,
  'template-children-modal': TemplateChildrenModal,
  'unlock-account-numbers-modal': UnlockAccountNumbersModal,
  'custom-reporting-modal': CustomReportingModal,
  'management-accounts-modal': ManagementAccountsModal,
  'wistia-video-modal': WistiaVideoModal,
  'contact-product-modal': ContactProductModal,
  'confirm-unreview-template-modal': ConfirmUnreviewTemplateModal,
  'confirm-change-account-detail-template-modal':
    ConfirmChangeAccountDetailTemplateModal,
  'confirm-accept-proposal-modal': ConfirmAcceptReconciliationProposalModal,
  'confirm-decline-proposal-modal': ConfirmDeclineReconciliationProposalModal,
  'pinned-message-removal-modal': PinnedMessageRemovalModal,
  'recurring-todo-removal-modal': RecurringTodoRemovalModal,
  'period-scope-for-update-modal': PeriodScopeForUpdateModal,
  'invoice-content-license-details-modal': InvoiceContentLicenseDetailsModal,
}
